import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
// import { AlertService } from '../_services/alert.service';
import { AuthenticationService } from '../_services/authentication.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { JsonPipe } from '@angular/common';
import { IfStmt } from '@angular/compiler';

declare var $: any;
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})

export class LoginComponent implements OnInit {

  model: any = {};
  loading = false;
  returnUrl: string;
  message: string;
  loginForm: FormGroup;
  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    // private alertService: AlertService
    ) { }

  ngOnInit(): void {
    this.authenticationService.logout();
    this.loginForm = this.formBuilder.group({
      phone: ['', Validators.required],
      password: ['', Validators.required]
    });
    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }

  // convenience getter for easy access to form fields
  get f() { return this.loginForm.controls; }

  login() {
    localStorage.removeItem("customerSignup");
    localStorage.removeItem("income_status");
    localStorage.removeItem("young_children")
    localStorage.removeItem("userIdWithhoutSignup");
    localStorage.removeItem("senior_status")
    localStorage.removeItem("userwithoutSignUp");
    localStorage.removeItem("health_insuarance_status");
    localStorage.removeItem("disability_status")
    localStorage.removeItem("veteran_status");


    if (this.loginForm.invalid) {
      return;
    } else {
      this.loading = true;
      this.authenticationService.login(this.loginForm.value)
        .subscribe(
          data => {
            if (JSON.stringify(data.status) == '200'){
              localStorage.setItem('currentUser', JSON.stringify(data));
              localStorage.setItem('isLoggedIn', 'true');
              let emergency = localStorage.getItem('emergency');
              let tax = localStorage.getItem('tax');

              if(tax == "true"){

                this.router.navigate(['/tax-assistamce'])


              } else {
                let foodService = localStorage.getItem('Eservice');
                let foodPincode = localStorage.getItem('EservicePincode');
  
                if(foodService != null && foodPincode != null){
                  this.router.navigate(['/food-service'])
                }
                else{
                  this.router.navigate(['/food'])
  
                }
              }

              
              // this.router.navigate(['/food-service'])
              // this.router.navigate([this.returnUrl]);
            }
            else{
              this.loading = false;
              console.log('error');
              alert('Incorrect Credentials')
            }
           
          },
          error => {
            // this.alertService.error(error);
            console.log('fail', error);
            this.loading = false;
            this.showNotification('bottom', 'right', 'warning', error.message, 'announcement');
          });
    }
  }

  withoutSignUp(){    
    localStorage.removeItem("currentUser");
    localStorage.removeItem("customerSignup")
    localStorage.removeItem("income_status");
    localStorage.removeItem("young_children")
    localStorage.removeItem("senior_status")
    localStorage.removeItem("health_insuarance_status");
    localStorage.removeItem("disability_status")
    localStorage.removeItem("veteran_status");

    this.router.navigate(['/user-signup']);

  }

  signUp(){

    localStorage.removeItem("currentUser");
    localStorage.removeItem("userwithoutSignUp")

    localStorage.removeItem("income_status");
    localStorage.removeItem("young_children")
    localStorage.removeItem("userIdWithhoutSignup");
    localStorage.removeItem("senior_status")
    localStorage.removeItem("userwithoutSignUp");
    localStorage.removeItem("health_insuarance_status");
    localStorage.removeItem("disability_status")
    localStorage.removeItem("veteran_status");



    
    this.router.navigate(['/customer-details']);

  }

  navigateFromLogin(){
    let isLoggedIn = localStorage.getItem('isLoggedIn');

    if(isLoggedIn === "true"){
      this.router.navigate(['/user-history'])
    } else {
      alert("No History Found, Please login")
    }
  }

  navigateMenu(){
    this.router.navigate(['/search1-screen']);
    console.log("navigateMenu")
  }

  forgotPassword(){
    console.log(this.loginForm.value)
    if(this.loginForm.value.phone != "" && this.loginForm.value.phone != null && this.loginForm.value.phone != undefined ){
      localStorage.setItem('isForgotPassword', 'true')
      localStorage.setItem('forgotPasswordPhone', this.loginForm.value.phone);
      this.router.navigate(['/otp-password']);
    }
    else {
      alert("Please fill the phone number")
    }
  }

  showNotification(from, align, color, stringMessage, icons) {
    const type = ['', 'info', 'success', 'warning', 'danger'];



    $.notify({
      icon: icons,
      message: stringMessage

    }, {
      type: type[color],
      timer: 4000,
      placement: {
        from: from,
        align: align
      },
      template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
        '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
        '<i class="material-icons" data-notify="icon">notifications</i> ' +
        '<span data-notify="title">{1}</span> ' +
        '<span data-notify="message">{2}</span>' +
        '<div class="progress" data-notify="progressbar">' +
        '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
        '</div>' +
        '<a href="{3}" target="{4}" data-notify="url"></a>' +
        '</div>'
    });
  }


}
